import Field from "@feniks-pwa/web-app/web/Components/Common/Form/Field/field";

import defaultClasses from "web/Pages/Checkout/Subscription/BenefitSummary/BenefitForm/benefitFormInput.scss";

const fieldClasses = {
  label: defaultClasses.label,
  labelText: defaultClasses.labelText_required,
};

const CheckoutSubscriptionBenefitFormInput = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Field classes={fieldClasses} {...props} />
);

export default CheckoutSubscriptionBenefitFormInput;
